import Icon from "@mui/icons-material/Filter9Plus";
import { EventSequenceList } from "./EventSequenceList";
import { EventSequenceCreate } from "./EventSequenceCreate";
import { EventSequenceEdit } from "./EventSequenceEdit";

export default {
  list: EventSequenceList,
  create: EventSequenceCreate,
  edit: EventSequenceEdit,
  icon: Icon,
  label: "Event sequences",
  options: { label: "Event sequences" },
  name: "eventSequences",
};
